<template>
    <section class="aboutus_main_page_wrp">
        <div class="container">
            <div class="public_bg_clr_wrp">
                <router-link to="/" class="home_rdrtc_cross">
                    <i aria-hidden="true" class="fa fa-times-circle-o mbl_cross"></i>
                </router-link>
                <div class="ab_section">
                    <div class="ab_content_center">
                        <h1 class="main_heading">LBIL - The Digital Front Door</h1>
                        <p class="section_heading pb-2"><span>Lymphomap Biotech India Limited</span> LBIL (<a
                                href="https://lbil.ai/">www.lbil.ai</a>) is an <span
                                class="popup_main_title_lymphomap">Artificial Intelligence</span> and <span
                                class="popup_main_title_lymphomap">Machine Learning</span> powered globally networked
                            hospital on the cloud containing telemedicine
                            facilities, virtual out-patient department (OPD), NGO and support groups, data repository
                            housing to securely store one’s medical health records, and many more features all
                            pertaining to digital healthcare and fitness.
                        </p>
                    </div>
                </div>
                <div class="ab_section">
                    <div class="ab_content_center">
                        <div class="accordion_box">
                            <div class="card" v-for="(item, index) in lbilAbout" :key="index">
                                <div class="card-header">
                                    <div class="card-link" href="javascript:void(0);">
                                        <span class="accordion_icon" v-html="item.icon"></span>
                                        <h3 class="accordion_title">{{ item.title }}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="btn_wrp">
                        <a href="https://lbil.ai/" class="btn btn-primary">Visit LBIL</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {
    bus
} from '@/main';
export default {
    name: 'LBIl-info-page',

    data() {
        return {
            lbilAbout: [{
                id: 'lbilAbout1', title: 'Digital Front Door for Patients',
                icon: `<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57.17 28.11" width="40" height="40"><path fill="#ffc107" class="cls-1" d="M58.32,35.76a.85.85,0,0,0-.62-.23,7,7,0,0,1-1-.05l.06-14.65.46,0h0a.85.85,0,0,0,.82-.88.85.85,0,0,0-.88-.83h0c-5,.17-7.84,3.85-10.43,7.76-3-3.74-6.15-7.2-11.05-7a9.6,9.6,0,0,0-6.43,2.86l-1.36.09-.53-.13L26.89,22l-.73-1-.9-1-.92-.84-.8-.62-1.1-.72-.91-.5-1.74-.71L18,16.15l-1.74-.21-1.7,0-1.94.26-1.91.55-1.43.61L7.47,18.43,6,19.58l-1,1-.61.69-.61.87-.95,1.63L2,26l-.44,2.09L1.41,30l.07,1.4.19,1.3.49,1.83L2.74,36l.82,1.5,1,1.35.83.93.88.84,1.2.94,1.44.88s.92.44,1,.51l1.44.53,1.65.4,1.79.21,1.64,0,1.43-.17L19,43.61l1.22-.37,1.68-.74,2.4-1.57L26,39.33l.9-1.12,1-1.69.46-1,1-.09A10,10,0,0,0,36.24,38c5.07-.17,7.93-4.12,10.58-8.17,3,3.84,6.14,7.61,10.94,7.45a.86.86,0,0,0,.56-1.48Zm-45.7-2.9a3.83,3.83,0,1,1-.36-5.41A3.83,3.83,0,0,1,12.62,32.86Zm19.57,2.42.61.7-.35-13.69a5.2,5.2,0,0,1,2.4-.69l.49,14.63A7.56,7.56,0,0,1,32.19,35.28Zm4.86.89-.49-14.63a7.87,7.87,0,0,1,3.52,1.17l.42,12A7.6,7.6,0,0,1,37.05,36.17Zm5.11-3-.53-9.38a30.68,30.68,0,0,1,4.08,4.53A36,36,0,0,1,42.16,33.21Zm5.65-4.93a39.51,39.51,0,0,1,2.75-3.8l.2,7.39C49.76,30.79,48.79,29.55,47.81,28.28Zm4.09-5.2A8.81,8.81,0,0,1,55,21.18l.28,14a8.88,8.88,0,0,1-2.78-1.6Z" transform="translate(-1.41 -15.94)"/><path fill="#ffc107" class="cls-1" d="M39.58,32.76a.83.83,0,0,0-.61-.23.86.86,0,0,0-.83.88h0a.87.87,0,0,0,.89.83.85.85,0,0,0,.82-.89h0A.82.82,0,0,0,39.58,32.76Z" transform="translate(-1.41 -15.94)"/><path fill="#ffc107" class="cls-1" d="M34.13,23.37a.92.92,0,0,0-.61-.23.87.87,0,0,0-.83.89h0a.87.87,0,0,0,.89.83A.86.86,0,0,0,34.4,24h0A.86.86,0,0,0,34.13,23.37Z" transform="translate(-1.41 -15.94)"/></svg>`,
            },
            {
                id: 'lbilAbout2', title: 'Electronic Medical Records Centre for Patients',
                icon: `<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57.17 28.11" width="40" height="40"><path fill="#ffc107" class="cls-1" d="M58.32,35.76a.85.85,0,0,0-.62-.23,7,7,0,0,1-1-.05l.06-14.65.46,0h0a.85.85,0,0,0,.82-.88.85.85,0,0,0-.88-.83h0c-5,.17-7.84,3.85-10.43,7.76-3-3.74-6.15-7.2-11.05-7a9.6,9.6,0,0,0-6.43,2.86l-1.36.09-.53-.13L26.89,22l-.73-1-.9-1-.92-.84-.8-.62-1.1-.72-.91-.5-1.74-.71L18,16.15l-1.74-.21-1.7,0-1.94.26-1.91.55-1.43.61L7.47,18.43,6,19.58l-1,1-.61.69-.61.87-.95,1.63L2,26l-.44,2.09L1.41,30l.07,1.4.19,1.3.49,1.83L2.74,36l.82,1.5,1,1.35.83.93.88.84,1.2.94,1.44.88s.92.44,1,.51l1.44.53,1.65.4,1.79.21,1.64,0,1.43-.17L19,43.61l1.22-.37,1.68-.74,2.4-1.57L26,39.33l.9-1.12,1-1.69.46-1,1-.09A10,10,0,0,0,36.24,38c5.07-.17,7.93-4.12,10.58-8.17,3,3.84,6.14,7.61,10.94,7.45a.86.86,0,0,0,.56-1.48Zm-45.7-2.9a3.83,3.83,0,1,1-.36-5.41A3.83,3.83,0,0,1,12.62,32.86Zm19.57,2.42.61.7-.35-13.69a5.2,5.2,0,0,1,2.4-.69l.49,14.63A7.56,7.56,0,0,1,32.19,35.28Zm4.86.89-.49-14.63a7.87,7.87,0,0,1,3.52,1.17l.42,12A7.6,7.6,0,0,1,37.05,36.17Zm5.11-3-.53-9.38a30.68,30.68,0,0,1,4.08,4.53A36,36,0,0,1,42.16,33.21Zm5.65-4.93a39.51,39.51,0,0,1,2.75-3.8l.2,7.39C49.76,30.79,48.79,29.55,47.81,28.28Zm4.09-5.2A8.81,8.81,0,0,1,55,21.18l.28,14a8.88,8.88,0,0,1-2.78-1.6Z" transform="translate(-1.41 -15.94)"/><path fill="#ffc107" class="cls-1" d="M39.58,32.76a.83.83,0,0,0-.61-.23.86.86,0,0,0-.83.88h0a.87.87,0,0,0,.89.83.85.85,0,0,0,.82-.89h0A.82.82,0,0,0,39.58,32.76Z" transform="translate(-1.41 -15.94)"/><path fill="#ffc107" class="cls-1" d="M34.13,23.37a.92.92,0,0,0-.61-.23.87.87,0,0,0-.83.89h0a.87.87,0,0,0,.89.83A.86.86,0,0,0,34.4,24h0A.86.86,0,0,0,34.13,23.37Z" transform="translate(-1.41 -15.94)"/></svg>`,
            },
            {
                id: 'lbilAbout3', title: 'Hospital and Doctor Aggregation for Patients',
                icon: `<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57.17 28.11" width="40" height="40"><path fill="#ffc107" class="cls-1" d="M58.32,35.76a.85.85,0,0,0-.62-.23,7,7,0,0,1-1-.05l.06-14.65.46,0h0a.85.85,0,0,0,.82-.88.85.85,0,0,0-.88-.83h0c-5,.17-7.84,3.85-10.43,7.76-3-3.74-6.15-7.2-11.05-7a9.6,9.6,0,0,0-6.43,2.86l-1.36.09-.53-.13L26.89,22l-.73-1-.9-1-.92-.84-.8-.62-1.1-.72-.91-.5-1.74-.71L18,16.15l-1.74-.21-1.7,0-1.94.26-1.91.55-1.43.61L7.47,18.43,6,19.58l-1,1-.61.69-.61.87-.95,1.63L2,26l-.44,2.09L1.41,30l.07,1.4.19,1.3.49,1.83L2.74,36l.82,1.5,1,1.35.83.93.88.84,1.2.94,1.44.88s.92.44,1,.51l1.44.53,1.65.4,1.79.21,1.64,0,1.43-.17L19,43.61l1.22-.37,1.68-.74,2.4-1.57L26,39.33l.9-1.12,1-1.69.46-1,1-.09A10,10,0,0,0,36.24,38c5.07-.17,7.93-4.12,10.58-8.17,3,3.84,6.14,7.61,10.94,7.45a.86.86,0,0,0,.56-1.48Zm-45.7-2.9a3.83,3.83,0,1,1-.36-5.41A3.83,3.83,0,0,1,12.62,32.86Zm19.57,2.42.61.7-.35-13.69a5.2,5.2,0,0,1,2.4-.69l.49,14.63A7.56,7.56,0,0,1,32.19,35.28Zm4.86.89-.49-14.63a7.87,7.87,0,0,1,3.52,1.17l.42,12A7.6,7.6,0,0,1,37.05,36.17Zm5.11-3-.53-9.38a30.68,30.68,0,0,1,4.08,4.53A36,36,0,0,1,42.16,33.21Zm5.65-4.93a39.51,39.51,0,0,1,2.75-3.8l.2,7.39C49.76,30.79,48.79,29.55,47.81,28.28Zm4.09-5.2A8.81,8.81,0,0,1,55,21.18l.28,14a8.88,8.88,0,0,1-2.78-1.6Z" transform="translate(-1.41 -15.94)"/><path fill="#ffc107" class="cls-1" d="M39.58,32.76a.83.83,0,0,0-.61-.23.86.86,0,0,0-.83.88h0a.87.87,0,0,0,.89.83.85.85,0,0,0,.82-.89h0A.82.82,0,0,0,39.58,32.76Z" transform="translate(-1.41 -15.94)"/><path fill="#ffc107" class="cls-1" d="M34.13,23.37a.92.92,0,0,0-.61-.23.87.87,0,0,0-.83.89h0a.87.87,0,0,0,.89.83A.86.86,0,0,0,34.4,24h0A.86.86,0,0,0,34.13,23.37Z" transform="translate(-1.41 -15.94)"/></svg>`
            },
            {
                id: 'lbilAbout4', title: 'Telemedicine and Remote Treatment for Patients',
                icon: `<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57.17 28.11" width="40" height="40"><path fill="#ffc107" class="cls-1" d="M58.32,35.76a.85.85,0,0,0-.62-.23,7,7,0,0,1-1-.05l.06-14.65.46,0h0a.85.85,0,0,0,.82-.88.85.85,0,0,0-.88-.83h0c-5,.17-7.84,3.85-10.43,7.76-3-3.74-6.15-7.2-11.05-7a9.6,9.6,0,0,0-6.43,2.86l-1.36.09-.53-.13L26.89,22l-.73-1-.9-1-.92-.84-.8-.62-1.1-.72-.91-.5-1.74-.71L18,16.15l-1.74-.21-1.7,0-1.94.26-1.91.55-1.43.61L7.47,18.43,6,19.58l-1,1-.61.69-.61.87-.95,1.63L2,26l-.44,2.09L1.41,30l.07,1.4.19,1.3.49,1.83L2.74,36l.82,1.5,1,1.35.83.93.88.84,1.2.94,1.44.88s.92.44,1,.51l1.44.53,1.65.4,1.79.21,1.64,0,1.43-.17L19,43.61l1.22-.37,1.68-.74,2.4-1.57L26,39.33l.9-1.12,1-1.69.46-1,1-.09A10,10,0,0,0,36.24,38c5.07-.17,7.93-4.12,10.58-8.17,3,3.84,6.14,7.61,10.94,7.45a.86.86,0,0,0,.56-1.48Zm-45.7-2.9a3.83,3.83,0,1,1-.36-5.41A3.83,3.83,0,0,1,12.62,32.86Zm19.57,2.42.61.7-.35-13.69a5.2,5.2,0,0,1,2.4-.69l.49,14.63A7.56,7.56,0,0,1,32.19,35.28Zm4.86.89-.49-14.63a7.87,7.87,0,0,1,3.52,1.17l.42,12A7.6,7.6,0,0,1,37.05,36.17Zm5.11-3-.53-9.38a30.68,30.68,0,0,1,4.08,4.53A36,36,0,0,1,42.16,33.21Zm5.65-4.93a39.51,39.51,0,0,1,2.75-3.8l.2,7.39C49.76,30.79,48.79,29.55,47.81,28.28Zm4.09-5.2A8.81,8.81,0,0,1,55,21.18l.28,14a8.88,8.88,0,0,1-2.78-1.6Z" transform="translate(-1.41 -15.94)"/><path fill="#ffc107" class="cls-1" d="M39.58,32.76a.83.83,0,0,0-.61-.23.86.86,0,0,0-.83.88h0a.87.87,0,0,0,.89.83.85.85,0,0,0,.82-.89h0A.82.82,0,0,0,39.58,32.76Z" transform="translate(-1.41 -15.94)"/><path fill="#ffc107" class="cls-1" d="M34.13,23.37a.92.92,0,0,0-.61-.23.87.87,0,0,0-.83.89h0a.87.87,0,0,0,.89.83A.86.86,0,0,0,34.4,24h0A.86.86,0,0,0,34.13,23.37Z" transform="translate(-1.41 -15.94)"/></svg>`,
            },
            {
                id: 'lbilAbout5', title: 'Virtual OPD, Virtual ICU and Virtual Operation Theatre for Doctors and Patients',
                icon: `<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57.17 28.11" width="40" height="40"><path fill="#ffc107" class="cls-1" d="M58.32,35.76a.85.85,0,0,0-.62-.23,7,7,0,0,1-1-.05l.06-14.65.46,0h0a.85.85,0,0,0,.82-.88.85.85,0,0,0-.88-.83h0c-5,.17-7.84,3.85-10.43,7.76-3-3.74-6.15-7.2-11.05-7a9.6,9.6,0,0,0-6.43,2.86l-1.36.09-.53-.13L26.89,22l-.73-1-.9-1-.92-.84-.8-.62-1.1-.72-.91-.5-1.74-.71L18,16.15l-1.74-.21-1.7,0-1.94.26-1.91.55-1.43.61L7.47,18.43,6,19.58l-1,1-.61.69-.61.87-.95,1.63L2,26l-.44,2.09L1.41,30l.07,1.4.19,1.3.49,1.83L2.74,36l.82,1.5,1,1.35.83.93.88.84,1.2.94,1.44.88s.92.44,1,.51l1.44.53,1.65.4,1.79.21,1.64,0,1.43-.17L19,43.61l1.22-.37,1.68-.74,2.4-1.57L26,39.33l.9-1.12,1-1.69.46-1,1-.09A10,10,0,0,0,36.24,38c5.07-.17,7.93-4.12,10.58-8.17,3,3.84,6.14,7.61,10.94,7.45a.86.86,0,0,0,.56-1.48Zm-45.7-2.9a3.83,3.83,0,1,1-.36-5.41A3.83,3.83,0,0,1,12.62,32.86Zm19.57,2.42.61.7-.35-13.69a5.2,5.2,0,0,1,2.4-.69l.49,14.63A7.56,7.56,0,0,1,32.19,35.28Zm4.86.89-.49-14.63a7.87,7.87,0,0,1,3.52,1.17l.42,12A7.6,7.6,0,0,1,37.05,36.17Zm5.11-3-.53-9.38a30.68,30.68,0,0,1,4.08,4.53A36,36,0,0,1,42.16,33.21Zm5.65-4.93a39.51,39.51,0,0,1,2.75-3.8l.2,7.39C49.76,30.79,48.79,29.55,47.81,28.28Zm4.09-5.2A8.81,8.81,0,0,1,55,21.18l.28,14a8.88,8.88,0,0,1-2.78-1.6Z" transform="translate(-1.41 -15.94)"/><path fill="#ffc107" class="cls-1" d="M39.58,32.76a.83.83,0,0,0-.61-.23.86.86,0,0,0-.83.88h0a.87.87,0,0,0,.89.83.85.85,0,0,0,.82-.89h0A.82.82,0,0,0,39.58,32.76Z" transform="translate(-1.41 -15.94)"/><path fill="#ffc107" class="cls-1" d="M34.13,23.37a.92.92,0,0,0-.61-.23.87.87,0,0,0-.83.89h0a.87.87,0,0,0,.89.83A.86.86,0,0,0,34.4,24h0A.86.86,0,0,0,34.13,23.37Z" transform="translate(-1.41 -15.94)"/></svg>`,
            }
            ],
        }
    },
    mounted() {
        bus.$emit('showHeaderbtn', false);
    },
    beforeCreate: function () {
        document.body.classList.add('left_sidebaar_disabled_for_page');
        document.body.classList.add('public_page_for_wrp_img');
    },
    beforeRouteLeave: function (to, from, next) {
        document.body.classList.remove('left_sidebaar_disabled_for_page');
        document.body.classList.remove('public_page_for_wrp_img');
        next();
    },
}
</script>

<style lang="scss" scoped>
@import url('../../../../assets/fonts/acetone/style.css');

.aboutus_main_page_wrp {
    padding: 70px 15px 10px;
    color: #FFFDD0;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji;

    @media only screen and (max-width:767px) {
        padding: 70px 0px 10px;
    }

    .main_heading {
        color: #d29e00;
        font-size: 40px;
        margin-bottom: 30px;
        font-family: 'origin_tech_demoregular';
        line-height: 1;
        text-align: center;

        @media only screen and (max-width:767px) {
            font-size: 24px;
            margin-bottom: 15px;
        }
    }

    .home_rdrtc_cross {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
        z-index: 100;
        padding: 4px 10px;
        color: #e4002b;
        font-size: 28px;
        background-color: rgba(31, 31, 31, 0.5);
        border-radius: 5px;
        line-height: 1;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        border: 1px solid rgba(174, 182, 184, 0.1);
        overflow: hidden;
        display: inline-block;

        &::before {
            content: "";
            position: absolute;
            top: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(120deg,
                    transparent,
                    rgba(255, 255, 255, 0.2),
                    transparent);
            left: -100%;
            transition: all 0.65s ease-in-out;
        }

        &:hover {
            box-shadow: 1px 1px 25px 10px rgba(255, 255, 255, 0.5) !important;
            color: #ffd400;

            &::before {
                left: 100%;
            }
        }
    }

    .public_bg_clr_wrp {
        background: rgba(0, 0, 0, .9);
        padding: 15px 25px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        position: relative;
        -webkit-box-shadow: 0 0 30px hsla(0, 0%, 100%, .045);
        box-shadow: 0 0 30px hsla(0, 0%, 100%, .045);
        flex-wrap: wrap;

        @media only screen and (max-width:767px) {
            padding:35px 15px 15px;
        }

        .ab_section {
            padding: 3% 0 0;
            width: 100%;
            @media only screen and (max-width:767px) {
              padding: 0;
            }

            .section_heading {
                span {
                    font-size: 28px;

                    @media only screen and (max-width:767px) {
                        font-size: 18px;
                    }

                    &.popup_main_title_lymphomap {
                        font-size: 24px;
                        @media only screen and (max-width:767px) {
                            font-size: 18px;
                        }
                    }
                }

                a {
                    color: #87cefa;
                    text-decoration: none;
                }
            }

            .btn_wrp {
                text-align: center;
                padding: 20px 0;

                .btn-primary {
                    background: none;
                    border: 2px solid #ffe400;
                    color: #ffe400 !important;
                    text-transform: uppercase;
                    font-size: 28px;
                    padding: 0px 20px;
                    line-height: 1;
                    height: auto;
                    border-radius: 6px;
                    -webkit-box-shadow: none !important;
                    box-shadow: none !important;
                    line-height: 40px;
                    font-family: 'ACETONE';

                    &:hover {
                        background: #ffe400;
                        color: #000000 !important;
                    }
                }
            }
        }
    }

    .accordion_box {
        .card {
            background: linear-gradient(-30deg, rgba(37, 44, 84, 0.8) 0%, rgba(0, 0, 0, 0.8) 50%, rgba(38, 38, 38, 0.8) 50%, rgba(44, 44, 84, 0.8) 100%);
            padding: 0px;
            margin: 20px 0;
            border-radius: 8px;
            -webkit-box-shadow: 0 5px 10px 0 rgba(244, 242, 238, 0.2);
            box-shadow: 0 5px 10px 0 rgba(244, 242, 238, 0.1);
            border: 1px solid rgba(93, 93, 93, 0.4);

            .card-header {
                background: transparent;
                padding: 0px;
                border: none;
            }

            .card-link {
                font-size: 18px;
                color: #fff9db;
                line-height: 1;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                padding: 15px;
                gap: 15px;
                position: relative;
                padding-right: 40px;
                @media only screen and (max-width:767px) {
                    padding-right: 15px;
                }

                .accordion_title {
                    margin: 0;
                    font-size: 20px;
                    @media only screen and (max-width:767px) {
                        font-size: 16px;
                    }
                }
            }
        }
    }
}
</style>